var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#FEF9EB",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2191 44L44.943 42.2761C45.4637 41.7554 45.4637 40.9112 44.943 40.3905L43.2191 38.6667M37.3335 41.3333L44.5524 41.3333",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 32C26.6665 29.7909 24.8756 28 22.6665 28H18.6665V36H22.6665C24.8756 36 26.6665 34.2091 26.6665 32V32Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 44H22.6668C20.4577 44 18.6668 42.2091 18.6668 40V24C18.6668 21.7909 20.4577 20 22.6668 20H41.3335C43.5426 20 45.3335 21.7909 45.3335 24V34.6667",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriend);
export default __webpack_public_path__ + "static/media/inviteFriend.6a516ca7789ffb80a88d8bdc2048600c.svg";
export { ForwardRef as ReactComponent };